import { useMediaQuery } from "react-responsive";

export const useResponsive = (props) => {
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-device-width: 1680px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isTablet = useMediaQuery({ query: '(min-device-width: 768px) and (max-device-width: 1224px)'});
    const isTabletOrMobileDevice = useMediaQuery({
        query: '(max-device-width: 1224px)'
    })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    return [isTabletOrMobileDevice, isTabletOrMobile, isBigScreen, isDesktopOrLaptop, isPortrait, isRetina, isTablet];
}